import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from "@aspnet/signalr"

enum JoinResult {
	Ok = 0,
	NotLoggedIn
}

class HubNotificationService {
	private notificationConnectionShouldBeOpen: boolean = false;
	private notificationConnection: HubConnection | null = null;

	public notLoggedIn: null | (() => void) = null
	public connectionStateChanged: null | ((isConnected: boolean) => void) = null

	public async openConnection (): Promise<HubConnection> {
		if (this.notificationConnection) {
			this.notificationConnection.invoke("leaveNotifications")
			this.notificationConnection.stop()
			this.notificationConnection = null
		}

		const notificationConnection = new HubConnectionBuilder()
			.withUrl(`${process.env.VUE_APP_HTTP_API_URI}notification-hub`)
			.configureLogging(LogLevel.Information)
			.build()

		let startedPromise = null
		const start: () => Promise<any> = () => {
			if (!notificationConnection || notificationConnection.state !== HubConnectionState.Disconnected || !this.notificationConnectionShouldBeOpen) {
				return Promise.resolve()
			}

			startedPromise = notificationConnection.start()
				.then(async () => {
					const result = await notificationConnection.invoke("joinNotifications")
					if (result === JoinResult.NotLoggedIn) {
						if (this.notLoggedIn !== null) {
							this.notLoggedIn()
						}
					} else {
						if (this.connectionStateChanged) {
							this.connectionStateChanged(true)
						}
					}
				})
				.catch(err => {
					if (this.connectionStateChanged) {
						this.connectionStateChanged(false)
					}
					console.error("HubNotificationService - failed to connect with hub:", err)
					return new Promise((resolve, reject) =>
						setTimeout(() => start()
							.then(resolve)
							.catch(reject),
						5000))
				})

			return startedPromise
		}
		notificationConnection.onclose(() => {
			if (this.notificationConnectionShouldBeOpen) {
				if (this.connectionStateChanged) {
					this.connectionStateChanged(false)
				}

				if (this.notificationConnection) {
					try {
						this.notificationConnection.stop()
					} catch {}
				}
				start()
			}
		})

		this.notificationConnectionShouldBeOpen = true
		await start()
		this.notificationConnection = notificationConnection

		return this.notificationConnection
	}

	public closeConnection () {
		if (this.notificationConnection) {
			this.notificationConnectionShouldBeOpen = false

			this.notificationConnection.stop()
			this.notificationConnection = null
		}
	}
}

const hubNotificationService = new HubNotificationService()
export default hubNotificationService
